import $ from 'jquery';


function singleBusinesses() {
	// Remove empty paragraph tags from the content editor
	$('.c-single-business_content p:empty').remove();
}

export { singleBusinesses }